// import { ButtonIcon } from "#common/Buttons"
import ButtonIcon from "#common/buttons/ButtonIcon"
import PERMISOS from "#constants/perfiles"
import { VACATION as VACATION_STATUS } from "#constants/StatusRequest "
import { UseHasPermission } from "#hooks/useHasPermission"
import STATUS from "#vacation/constants"
import { UseVacationContext } from "#vacation/contexts/VacationContext"
import EditNoteRoundedIcon from "@mui/icons-material/EditNoteRounded"
import EventAvailableIcon from "@mui/icons-material/EventAvailable"
import EventBusyIcon from "@mui/icons-material/EventBusy"
import Box from "@mui/material/Box"
import Card from "@mui/material/Card"
import CardActions from "@mui/material/CardActions"
import CardContent from "@mui/material/CardContent"
import CardMedia from "@mui/material/CardMedia"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import { useCallback } from "react"

export default function ColaboradorCard({ ...props }) {
	const { photo, colaborador_name, status_name } = props
	const { departamento, authorize_name } = props
	const { date_start = 0, date_end = 0 } = props
	const StyleSubText = {
		variant: "subtitle1",
		color: "text.secondary",
		component: "div",
	}

	return (
		<Card
			sx={{
				display: "flex",
				alignItems: "center",
				height: "100%",
				width: {
					md: 550, // Para md y arriba
				},
			}}
		>
			<CardMedia
				component="img"
				sx={{ width: 75, height: 210, objectFit: "cover" }}
				image={photo}
				alt="colaborador"
				onError={(e) => {
					e.target.onerror = null
					e.target.src =
						"https://imagenespublicas.s3.us-east-2.amazonaws.com/usuario.webp"
				}}
			/>
			<Box sx={{ display: "flex", flexDirection: "column" }}>
				<CardContent sx={{ flex: "1 0 auto" }}>
					<Typography component="div" variant="h5">
						{colaborador_name}
					</Typography>
					<Typography {...StyleSubText} alignItems={"center"}>
						Status: <strong>{status_name}</strong>
					</Typography>
					<Stack direction={"column"} spacing={-0.5}>
						<Typography {...StyleSubText}>{departamento}</Typography>
						<Stack direction={"row"} spacing={2} alignItems={"flex-start"}>
							<Typography {...StyleSubText} alignItems={"center"}>
								<strong>{date_start}</strong>
							</Typography>
							<Typography {...StyleSubText} alignItems={"center"}>
								a{" "}
							</Typography>

							<Typography {...StyleSubText} alignItems={"center"}>
								<strong>{date_end}</strong>
							</Typography>
						</Stack>
						<Typography {...StyleSubText} alignItems={"center"}>
							Autoriza: <strong>{authorize_name}</strong>
						</Typography>
						{/* <Typography {...StyleSubText}>
							Dias solicitados: <strong>{days}</strong>
						</Typography> */}
						{/* <Typography {...StyleSubText} alignItems={"center"}>
							Solicitada: <strong>{created_at}</strong>
						</Typography> */}
						{/* {date_approval && (
							<Typography {...StyleSubText} alignItems={"center"}>
								aprobada el : <strong>{date_approval}</strong>
						-	</Typography>
						)} */}
					</Stack>
				</CardContent>
				<CardActions>
					<ButtonVacations {...props} />
				</CardActions>
			</Box>
		</Card>
	)
}

const ButtonVacations = ({ ...props }) => {
	const isRh = UseHasPermission(PERMISOS.RH)
	const { setOpenApprove, setVacation, setOpenRequest } = UseVacationContext()
	const { SOLICITADA, APPROVE, RECHAZADA, CANCELADAS } = VACATION_STATUS
	const noValidadas = [RECHAZADA, CANCELADAS]
	const { status } = props
	let buttons = []

	const handleData = useCallback(() => {
		setVacation({
			id: props.id,
			colaborador: props.colaborador,
			available_days: props.available_days,
			days: props.days,
			date_start: props.date_start,
			date_end: props.date_end,
			status: props.status,
		})
	}, [
		setVacation,
		props.id,
		props.colaborador,
		props.available_days,
		props.days,
		props.date_start,
		props.date_end,
		props.status,
	])

	if (STATUS.APPROVE === status && isRh && !noValidadas.includes(status)) {
		buttons.push(
			<ButtonIcon
				key="Cancelar"
				title="Cancelar"
				icon={<EventBusyIcon sx={{ fontSize: 30, color: "red" }} />}
				onClick={() => {
					setOpenApprove(true)
					handleData()
				}}
			/>
		)
	}

	if (status === SOLICITADA) {
		buttons.push(
			<ButtonIcon
				key="aceptar"
				title="Aceptar"
				icon={<EventAvailableIcon sx={{ fontSize: 30, color: "green" }} />}
				onClick={() => {
					setOpenApprove(true)
					setVacation({ ...props })
					handleData()
				}}
			/>
		)
	}

	if (status === APPROVE && isRh) {
		buttons.push(
			<ButtonIcon
				key="editar"
				title="Editar"
				icon={<EditNoteRoundedIcon sx={{ fontSize: 30 }} />}
				onClick={() => {
					setOpenRequest(true)
					handleData()
				}}
			/>
		)
	}

	return (
		<Stack direction={"row"} spacing={3}>
			{buttons}
		</Stack>
	)
}
